
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-982b3c40&scoped=true!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./UserInfo.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./UserInfo.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-982b3c40!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./UserInfo.vue"),
  /* scopeId */
  "data-v-982b3c40",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/panels/UserInfo.vue
// module id = 845
// module chunks = 2